import React, { useEffect, useMemo } from 'react';
import { bool, func, object, oneOf, shape } from 'prop-types';

import { Row, Col } from '@ajaibid/components';
import { PopUpCenterV2 } from 'Component/PopUp';
import { StockBuySellProvider } from '@context/stock/buysell';

import OrderBookSection from '@screens/StockDetail/OrderBookSection';

import StockAmend from './StockAmend';
import { transformOrderDetail } from './adapter';
import { styPopupContainer, styPopupInner } from './style';
import useEventTracker from './tracker';

const PopUpStockAmend = (props) => {
  const { data, show, onHide } = props;
  const orderDetail = useMemo(() => transformOrderDetail(data), [data]);
  const { eventShowPopupAmend } = useEventTracker({ orderDetail });

  useEffect(() => {
    if (!show) return;
    eventShowPopupAmend();
  }, [show]);

  return (
    <PopUpCenterV2 size="lg" className={styPopupContainer} show={show} onHide={onHide}>
      <Row gutters={2} align="center-stretch">
        <Col size={6}>
          <div className={styPopupInner}>
            <OrderBookSection code={orderDetail?.code} />
          </div>
        </Col>
        <Col size={6}>
          <div className={styPopupInner}>
            <StockAmend orderDetail={orderDetail} onCancel={onHide} />
          </div>
        </Col>
      </Row>
    </PopUpCenterV2>
  );
};

PopUpStockAmend.propTypes = {
  data: shape({
    accountType: oneOf(['REGULAR', 'DAY_TRADING', 'MARGIN_TRADING']),
    orderType: oneOf(['LIMIT', 'AUTO']),
    orderDetail: object,
  }),
  show: bool,
  onHide: func,
};

PopUpStockAmend.defaultProps = {
  data: {
    accountType: 'REGULAR',
    orderType: 'LIMIT',
    orderDetail: {},
  },
  show: false,
  onHide: () => {},
};

const WrappedPopUpStockAmend = (props) => (
  // Wrap component in another StockBuySellProvider
  // as StockAmend state should not be shared with StockBuySell
  <StockBuySellProvider>
    <PopUpStockAmend {...props} />
  </StockBuySellProvider>
);

export default WrappedPopUpStockAmend;
